import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5b66a307&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b66a307')) {
      api.createRecord('5b66a307', component.options)
    } else {
      api.reload('5b66a307', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=5b66a307&", function () {
      api.rerender('5b66a307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/Main.vue"
export default component.exports